import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Loader2 } from "lucide-react";
import AdminShell from "@/components/AdminShell";
import api from "@/lib/api";

function Stat({ label, value, accent = false, testid }) {
    return (
        <div className="card-surface p-6" data-testid={testid}>
            <div className="eyebrow mb-3">{label}</div>
            <div className={`font-mono text-3xl lg:text-4xl ${accent ? "text-saffron" : "text-white"}`}>
                {value}
            </div>
        </div>
    );
}

export default function AdminDashboard() {
    const [m, setM] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api
            .get("/admin/metrics")
            .then((r) => setM(r.data))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return (
            <AdminShell title="Overview">
                <Loader2 className="animate-spin text-saffron" size={20} />
            </AdminShell>
        );
    }
    if (!m) return <AdminShell title="Overview" />;

    return (
        <AdminShell title="Overview">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4 mb-10">
                <Stat label="Total Applications" value={m.total_applications} testid="metric-total-apps" />
                <Stat label="Total Revenue (₹)" value={`₹${m.total_revenue_inr.toLocaleString("en-IN")}`} accent testid="metric-revenue" />
                <Stat label="Pending Payments" value={m.pending_payments} testid="metric-pending-payments" />
                <Stat label="Upcoming Appointments" value={m.upcoming_appointments} testid="metric-upcoming-appointments" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 lg:gap-4">
                {[
                    ["client", "Brands", "/admin/clients"],
                    ["doctor", "Dr. Aangan Theory", "/admin/doctor"],
                    ["academy", "Aangan Academy", "/admin/academy"],
                    ["career", "Careers", "/admin/careers"],
                ].map(([key, label, to]) => (
                    <Link
                        key={key}
                        to={to}
                        className="card-surface p-6 lg:p-8 group flex items-center justify-between"
                        data-testid={`pipeline-card-${key}`}
                    >
                        <div>
                            <div className="eyebrow mb-3">Pipeline · {label}</div>
                            <div className="font-mono text-3xl text-white">{m.counts[key] || 0}</div>
                            <div className="text-white/55 text-sm mt-2">applications</div>
                        </div>
                        <ArrowUpRight size={18} className="text-white/40 group-hover:text-saffron transition-colors" />
                    </Link>
                ))}
            </div>
        </AdminShell>
    );
}
